import type { ReactNode } from "react";

interface IContentSectionHeadingProps {
  children: ReactNode;
}

export default function ContentSectionHeading({ children }: IContentSectionHeadingProps) {
  return (
    <h1 className="m-0 truncate font-aeonik text-base font-bold uppercase text-gray-700 xl:text-lg">{children}</h1>
  );
}
